import Api from '@/utils/api'
import BasicConfig from '@/config/basic'

// 获取ERP 销售快报-首页概况数据
export function getERPSalesReportHomeSummary (body) {
  return Api.post(
    `${BasicConfig.shixinlDomain}/api.php/OnlineMarketingNew/getHomeData`, 
    {
      ...body,
      axiosType: 'erpAPI'
    }
  )
}

// 获取ERP 门店年度统计数据
export function getERPgetStoreAnnualStatistics (body) {
  return Api.post(
    `${BasicConfig.shixinlDomain}/api.php/OnlineMarketingNew/getStoreAnnualStatistics`, 
    {
      ...body,
      axiosType: 'erpAPI'
    }
  )
}

// 获取ERP 门店列表
export function getERPgetStoreList (body) {
  return Api.post(
    `${BasicConfig.shixinlDomain}/api.php/SendGift/getStoreList`, 
    {
      ...body,
      axiosType: 'erpAPI'
    }
  )
}

// 获取ERP 销售业绩目标
export function getERPStoreSalesTaget (body) {
  return Api.post(
    `${BasicConfig.shixinlDomain}/api.php/OnlineMarketing/getStoreSalesTaget`, 
    {
      ...body,
      axiosType: 'erpAPI'
    }
  )
}

// 获取ERP 门店对比接口
export function getERPStoreDataByDay (body) {
  return Api.post(
    `${BasicConfig.shixinlDomain}/api.php/OnlineMarketingNew/getStoreDataByDay`, 
    {
      ...body,
      axiosType: 'erpAPI'
    }
  )
}

// 获取ERP 会员列表（用于测试 MemberController 的加密接口）
export function getERPRoomList (query) {
  return Api.post(
    `${BasicConfig.shixinlDomain}/api.php/MemberController/member_list`,
    {
      ...query,
      axiosType: 'erpAPI'
    }
  )
}

// 获取ERP 房间列表
export function getERPRoomListPost (body) {
  return Api.post(
    `${BasicConfig.shixinlDomain}/api.php/Sop/getTasksList`,
    {
      ...body,
      axiosType: 'erpAPI'
    }
  )
}